import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { AcademicFormValues, Props } from './studentAcademicForm.type';
import { transformInputDate } from 'helpers/utils';

function StudentAcademicForm({ innerRef, data, isReadOnly }: Props) {
  const handleSubmit = (values: AcademicFormValues) => {
    return Promise.resolve(values);
  };
  return (
    <Formik
      innerRef={innerRef}
      initialValues={{
        course: data?.info?.academicInfo?.course ?? '',
        department: data?.info?.academicInfo?.department ?? '',
        yearOfStudy: data?.info?.academicInfo?.yearOfStudy ?? '',
        academicAdvisor: data?.info?.academicInfo?.academicAdvisor ?? '',
        enrollmentDate: data?.info?.academicInfo?.enrollmentDate
          ? transformInputDate(data.info.academicInfo.enrollmentDate)
          : '',
        expectedGraduationDate: data?.info?.academicInfo?.expectedGraduationDate
          ? transformInputDate(data.info.academicInfo.expectedGraduationDate)
          : ''
      }}
      onSubmit={handleSubmit}
    >
      <Form>
        <Row className="g-5">
          <Col xs={12} xl={6}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="course">Course</FormLabel>
              <Input name="course" id="course" disabled={isReadOnly} />
            </FormGroup>
          </Col>
          <Col xs={12} xl={3}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="department">Department</FormLabel>
              <Input name="department" id="department" disabled={isReadOnly} />
            </FormGroup>
          </Col>
          <Col xs={12} xl={3}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="yearOfStudy">Year Of Study</FormLabel>
              <Input
                name="yearOfStudy"
                id="yearOfStudy"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="academicAdvisor">Academic Advisor</FormLabel>
              <Input
                name="academicAdvisor"
                id="academicAdvisor"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="enrollmentDate">Enrollment Date</FormLabel>
              <Input
                name="enrollmentDate"
                id="enrollmentDate"
                type="date"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="expectedGraduationDate">
                Expected Graduation Date
              </FormLabel>
              <Input
                name="expectedGraduationDate"
                id="expectedGraduationDate"
                type="date"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </Formik>
  );
}

export default StudentAcademicForm;
